import React from 'react';
import '../../styles/PageHeader.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backgroundImageUrl?: string;
}

/**
 * Reusable page header component with background image and text overlay
 */
const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  subtitle, 
  backgroundImageUrl = '/images/background.jpg' 
}) => {
  // Determine if title is long (e.g., German words like Datenschutzerklärung)
  const isLongTitle = title.length > 15;
  
  return (
    <div className="page-header" style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
      <div className="page-header-overlay"></div>
      <div className="page-header-content">
        <h1 className={`text-center page-header-title ${isLongTitle ? 'long-title' : ''}`}>
          {title}
        </h1>
        {subtitle && <p className="text-center">{subtitle}</p>}
      </div>
    </div>
  );
};

export default PageHeader;
